import { useEffect, useState } from 'react';
import {
  getAdminGlobalKpis,
  readAdminGlobalKpisCache,
  writeAdminGlobalKpisCache,
} from '../../utils/adminAnalyticsKpis';

const KPI_ITEMS = [
  { key: 'clients', label: 'Clients' },
  { key: 'users', label: 'Users' },
  { key: 'checkpointsCompleted', label: 'Checkpoints Completed' },
  { key: 'bootcampsCompleted', label: 'Bootcamps Completed' },
  { key: 'reflectionsWritten', label: 'Reflections Written' },
];

function AdminAnalyticsLanding({ hierarchy, showGlobalKpis = true }) {
  const [kpis, setKpis] = useState(() => readAdminGlobalKpisCache());
  const [loading, setLoading] = useState(!readAdminGlobalKpisCache());
  const [error, setError] = useState('');

  useEffect(() => {
    if (!showGlobalKpis) {
      setLoading(false);
      return undefined;
    }
    let mounted = true;
    const run = async () => {
      const cached = readAdminGlobalKpisCache();
      if (cached) {
        setKpis(cached);
        setLoading(false);
        return;
      }
      setLoading(true);
      setError('');
      try {
        const data = await getAdminGlobalKpis();
        if (!mounted) return;
        writeAdminGlobalKpisCache(data);
        setKpis(data);
      } catch {
        if (mounted) setError('Could not load overview metrics');
      } finally {
        if (mounted) setLoading(false);
      }
    };
    run();
    return () => { mounted = false; };
  }, [showGlobalKpis]);

  const clients = hierarchy.clients || [];

  return (
    <div>
      {error && <div className="modern-error modern-mb-4">{error}</div>}

      {showGlobalKpis && (
        <div className="analytics-kpi-grid">
          {KPI_ITEMS.map(({ key, label }) => (
            <div key={key} className="analytics-kpi-card">
              <div className="analytics-kpi-label">{label}</div>
              <div className="analytics-kpi-value">
                {loading && !kpis ? '…' : (kpis?.[key] ?? 0).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      )}

      <h2 className={`modern-heading modern-mb-4${showGlobalKpis ? ' modern-mt-6' : ''}`}>Clients</h2>
      <div className="modern-list-panel">
        {clients.length === 0 ? (
          <div className="modern-list-empty">No clients found.</div>
        ) : (
          clients.map((client) => (
            <div
              key={client.id}
              className="modern-list-row modern-list-row-clickable"
              onClick={() => hierarchy.setClient(String(client.id))}
            >
              <span className="modern-list-row-label">{client.business_name || 'Untitled Client'}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default AdminAnalyticsLanding;
